import { render, staticRenderFns } from "./MpnLabelNumber.vue?vue&type=template&id=1424bd80&"
import script from "./MpnLabelNumber.vue?vue&type=script&lang=js&"
export * from "./MpnLabelNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports